import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { DepotSchemaConfig } from './domain/depot-schema-config';
import { DataLinkRepository } from './domain/depot.types';
import {
	openCreateEntityFromDepotModal,
	openCreateDepotModal,
	openDepotHeaderFieldsSelection,
	openChangeVersionModal,
	openSendEmailPopup,
} from './store';

@Injectable()
export class NgDepot {
	public constructor(private readonly store: Store) {}

	public openHeaderFieldsSelection(
		params: DepotSchemaConfig,
		currentSchema: unknown | null
	): void {
		this.store.dispatch(
			openDepotHeaderFieldsSelection({
				currentSchema,
				params,
			})
		);
	}

	public openCreateEntityFromDepotModal(
		depotId: number,
		depotLabel: string,
		depotType: string
	): void {
		this.store.dispatch(
			openCreateEntityFromDepotModal({
				depotId,
				depotLabel,
				depotType,
			})
		);
	}

	public openCreateDepotModal(): void {
		this.store.dispatch(openCreateDepotModal());
	}

	public openChangeVersionModal(selectedRepo: DataLinkRepository): void {
		this.store.dispatch(
			openChangeVersionModal({
				depot: selectedRepo,
			})
		);
	}

	public openSendEmailPopup(depotId: number): void {
		this.store.dispatch(
			openSendEmailPopup({
				depotId,
			})
		);
	}
}
